import React from "react";
import Nav from "./nav";
import { Link } from "react-router-dom";
import { IoSunnyOutline, IoMoonOutline } from "react-icons/io5";
import { useLanguage } from "./LanguageContext";
import { useTheme } from "./ThemeContext";

import "../assets/css/header.css";
import "../assets/css/font.css";

function Header() {
  const { lang, toggleLanguage } = useLanguage();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="main-header">
      <Link to={`/${lang}`} className="main-header-text">
        Vinícius Gabriel
      </Link>
      <div className="header-actions">
        <button
          type="button"
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
        >
          {theme === "dark" ? <IoSunnyOutline /> : <IoMoonOutline />}
        </button>
        <button
          type="button"
          className="language-toggle mono"
          onClick={toggleLanguage}
          aria-label={
            lang === "pt" ? "Switch to English" : "Mudar para português"
          }
        >
          {lang === "pt" ? "EN" : "PT"}
        </button>
        <Nav />
      </div>
    </header>
  );
}

export default Header;
